(() => {
  if (window.kvStorefrontLoaded) return;
  window.kvStorefrontLoaded = true;
  const configElement = document.getElementById('kv-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const cartDialog = document.getElementById('kv-cart');
  const money = value => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency, maximumFractionDigits: value % 100 ? 2 : 0 }).format(value / 100);
  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  let cartBusy = false;
  async function request(url, options = {}) {
    const response = await fetch(root + url, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config.text.error);
    return result;
  }
  function updateCounts(cart) {
    document.querySelectorAll('[data-kv-count]').forEach(count => { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; });
  }
  function renderCart(cart) {
    const list = cartDialog.querySelector('[data-kv-cart-items]');
    list.replaceChildren();
    for (const item of cart.items) {
      const row = create('div', 'kv-cart-line');
      const link = create('a');
      link.href = item.url;
      const image = create('img');
      image.src = item.featured_image?.url || item.image;
      image.alt = item.product_title;
      image.width = 88;
      image.height = 88;
      link.append(image);
      const copy = create('div');
      const title = create('h3');
      const titleLink = create('a', '', item.product_title);
      titleLink.href = item.url;
      title.append(titleLink);
      copy.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') copy.append(create('p', '', item.variant_title));
      if (item.selling_plan_allocation) copy.append(create('p', '', item.selling_plan_allocation.selling_plan.name));
      const label = create('label', 'kv-cart-quantity-label', config.text.quantity + ' ');
      const quantity = create('input');
      quantity.type = 'number';
      quantity.min = '0';
      quantity.step = '1';
      quantity.value = item.quantity;
      quantity.dataset.kvCartQuantity = item.key;
      quantity.setAttribute('aria-label', config.text.quantity + ': ' + item.product_title);
      label.append(quantity);
      copy.append(label, create('strong', '', money(item.final_line_price)));
      const remove = create('button', '', config.text.remove);
      remove.type = 'button';
      remove.dataset.kvRemove = item.key;
      remove.setAttribute('aria-label', config.text.remove + ': ' + item.product_title);
      row.append(link, copy, remove);
      list.append(row);
    }
    cartDialog.querySelector('[data-kv-cart-empty]').hidden = cart.item_count > 0;
    cartDialog.querySelector('[data-kv-cart-bottom]').hidden = cart.item_count === 0;
    cartDialog.querySelector('[data-kv-cart-total]').textContent = money(cart.total_price);
    updateCounts(cart);
  }
  async function openCart(message = '') {
    if (!cartDialog.open) cartDialog.showModal();
    const status = cartDialog.querySelector('[data-kv-cart-status]');
    status.textContent = config.text.loading;
    try {
      renderCart(await request('cart.js'));
      status.textContent = message;
    } catch (error) {
      status.textContent = error.message || config.text.error;
      const fallback = create('a', 'kv-text-link', config.text.cartLink);
      fallback.href = root + 'cart';
      status.append(document.createElement('br'), fallback);
    }
  }
  async function changeLine(key, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    const controls = cartDialog.querySelectorAll('[data-kv-remove], [data-kv-cart-quantity]');
    controls.forEach(control => control.disabled = true);
    const status = cartDialog.querySelector('[data-kv-cart-status]');
    status.textContent = config.text.loading;
    try {
      renderCart(await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) }));
      status.textContent = quantity === 0 ? config.text.removed : '';
    } catch (error) {
      status.textContent = error.message || config.text.error;
      try { renderCart(await request('cart.js')); } catch {}
    } finally {
      cartBusy = false;
      controls.forEach(control => control.disabled = false);
    }
  }
  // KB — vald variant och köpsätt (facit: PurchaseOption). Priset, jämförpriset och mängdpriset följer prenumerationsplanen.
  function currentVariant(section) {
    const field = section.querySelector('[data-kv-variant]') || section.querySelector('form[data-kv-add] [name=id]');
    const variants = JSON.parse(section.querySelector('[data-kv-variants]').textContent);
    return variants.find(item => String(item.id) === field.value);
  }
  function updatePurchase(section) {
    const variant = currentVariant(section);
    if (!variant) return;
    const checked = section.querySelector('[name=selling_plan]:checked');
    const planId = checked ? checked.value : '';
    const plans = variant.plans || {};
    const plan = planId ? plans[planId] : null;
    const shown = plan || variant;
    section.querySelectorAll('[data-kv-price]').forEach(price => price.textContent = shown.price);
    section.querySelector('[data-kv-unit]').textContent = shown.unit;
    const unitRow = section.querySelector('[data-kv-unit-row]');
    if (unitRow) unitRow.hidden = !shown.unit;
    const saving = section.querySelector('[data-kv-saving]');
    if (saving) { saving.textContent = shown.saving || ''; saving.hidden = !shown.saving; }
    section.querySelectorAll('[data-kv-plan-flag]').forEach(flag => flag.hidden = !plan);
    const all = JSON.parse(section.querySelector('[data-kv-variants]').textContent);
    section.querySelectorAll('[data-kv-option]').forEach(button => {
      const unit = button.querySelector('[data-kv-option-unit]');
      const item = all.find(entry => String(entry.id) === button.dataset.kvOption);
      if (unit && item) unit.textContent = (planId && item.plans && item.plans[planId] ? item.plans[planId] : item).unit;
    });
    const onePrice = section.querySelector('[data-kv-one-price]');
    if (onePrice) onePrice.textContent = variant.price;
    const planPrice = section.querySelector('[data-kv-plan-price]');
    if (planPrice) {
      const firstPlan = section.querySelector('[name=selling_plan]:not([value=""])');
      const listed = plan || (firstPlan && plans[firstPlan.value]);
      planPrice.textContent = listed ? listed.price : '';
      const month = section.querySelector('[data-kv-plan-month]');
      if (month) month.textContent = listed && listed.month ? listed.month : '';
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    if (planId) url.searchParams.set('selling_plan', planId); else url.searchParams.delete('selling_plan');
    history.replaceState({}, '', url);
  }
  function updateVariant(section) {
    const select = section.querySelector('[data-kv-variant]');
    const variant = currentVariant(section);
    if (!variant) return;
    section.querySelectorAll('[data-kv-variant-title]').forEach(title => title.textContent = variant.title);
    section.querySelectorAll('[data-kv-option]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.kvOption === select.value)));
    section.querySelectorAll('[data-kv-buy]').forEach(buy => {
      buy.disabled = !variant.available;
      buy.querySelector('span:not(.kv-icon)').textContent = variant.available ? config.text.add : config.text.soldOut;
    });
    const quantity = section.querySelector('[name=quantity]');
    quantity.min = variant.min;
    quantity.step = variant.step;
    if (variant.max !== null) quantity.max = variant.max; else quantity.removeAttribute('max');
    quantity.value = variant.min;
    updatePurchase(section);
  }
  // KB — fast köpfält på mobil när köpknappen inte syns, så att pris och köp finns på första skärmen (facit: StickyBuy)
  function initStickyBuy() {
    const section = document.querySelector('[data-kv-product]');
    const bar = section && section.querySelector('[data-kv-sticky]');
    const buy = section && section.querySelector('[data-kv-buy]:not([form])');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    let buyVisible = true, footerVisible = false;
    const update = () => { bar.hidden = buyVisible || footerVisible; };
    new IntersectionObserver(entries => { buyVisible = entries[0].isIntersecting; update(); }).observe(buy);
    const footer = document.querySelector('.kv-footer');
    if (footer) new IntersectionObserver(entries => { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
  }
  // KB — välj efter fyllighet eller koffeinfritt på kollektionen (facit: TasteFilter)
  function initTasteFilter() {
    const root = document.querySelector('[data-kv-taste-filter]');
    if (!root) return;
    const items = [...document.querySelectorAll('.kv-collection-card')];
    if (!items.length) return;
    root.hidden = false;
    const status = root.querySelector('[data-kv-filter-status]');
    root.addEventListener('click', event => {
      const chip = event.target.closest('[data-kv-filter]');
      if (!chip) return;
      const value = chip.dataset.kvFilter;
      root.querySelectorAll('[data-kv-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === chip)));
      let shown = 0;
      items.forEach(item => {
        const card = item.querySelector('.kv-card');
        const match = !value || (value === 'koffeinfritt' ? card.hasAttribute('data-decaf') : card.dataset.body === value);
        item.hidden = !match;
        if (match) shown += 1;
      });
      status.textContent = config.text.filterShown.replace('{{ n }}', shown);
    });
  }
  function initialize() {
    initStickyBuy();
    initTasteFilter();
    document.querySelectorAll('.kv-header').forEach(header => header.dataset.enhanced = '');
    document.querySelectorAll('[data-kv-product]').forEach(section => {
      section.dataset.enhanced = '';
      const buttons = section.querySelector('[data-kv-variant-buttons]');
      if (buttons) {
        buttons.hidden = false;
        // KB — väljaren finns kvar för formuläret men ska varken nås med tangentbord eller läsas upp när knapparna visas
        const select = section.querySelector('[data-kv-variant]');
        const label = select && section.querySelector(`label[for="${select.id}"]`);
        if (select) { select.tabIndex = -1; select.setAttribute('aria-hidden', 'true'); }
        if (label) { label.id = `${select.id}-label`; label.removeAttribute('for'); buttons.removeAttribute('aria-label'); buttons.setAttribute('aria-labelledby', label.id); }
      }
      if (section.querySelector('[name=selling_plan]:checked:not([value=""])')) updatePurchase(section);
    });
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-kv-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type=submit]');
    if (form.dataset.pending) return;
    form.dataset.pending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const errorBox = form.querySelector('[data-kv-error]');
    errorBox.hidden = true;
    try {
      await request('cart/add.js', { method: 'POST', body: new FormData(form) });
      await openCart(config.text.added);
    } catch (error) {
      errorBox.textContent = error.message || config.text.error;
      errorBox.hidden = false;
    } finally {
      delete form.dataset.pending;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-kv-variant]')) updateVariant(event.target.closest('[data-kv-product]'));
    if (event.target.matches('[data-kv-purchase-type] [name=selling_plan]')) updatePurchase(event.target.closest('[data-kv-product]'));
    if (event.target.matches('[data-kv-cart-quantity]')) {
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) changeLine(event.target.dataset.kvCartQuantity, quantity);
    }
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-kv-cart-open]');
    if (opener) { event.preventDefault(); openCart(); return; }
    const close = event.target.closest('[data-kv-close]');
    if (close) { close.closest('dialog').close(); return; }
    const menu = event.target.closest('[data-kv-menu]');
    if (menu) {
      const header = menu.closest('.kv-header');
      const open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open));
      header.toggleAttribute('data-menu-open', open);
      return;
    }
    const planHead = event.target.closest('[data-kv-plan-head]');
    if (planHead) {
      const box = planHead.parentElement;
      if (!box.querySelector('[name=selling_plan]:checked')) {
        const first = box.querySelector('[name=selling_plan]');
        first.checked = true;
        first.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    const option = event.target.closest('[data-kv-option]');
    if (option) {
      const section = option.closest('[data-kv-product]');
      section.querySelector('[data-kv-variant]').value = option.dataset.kvOption;
      updateVariant(section);
      return;
    }
    const step = event.target.closest('[data-kv-quantity]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      if (Number(step.dataset.kvQuantity) > 0) input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const thumbnail = event.target.closest('[data-kv-thumb]');
    if (thumbnail) {
      const section = thumbnail.closest('[data-kv-product]');
      const image = section.querySelector('[data-kv-main-image]');
      image.removeAttribute('srcset');
      image.src = thumbnail.dataset.src;
      document.querySelector('#kv-zoom img').src = thumbnail.dataset.full;
      section.querySelectorAll('[data-kv-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
      return;
    }
    if (event.target.closest('[data-kv-zoom]')) { document.getElementById('kv-zoom').showModal(); return; }
    const remove = event.target.closest('[data-kv-remove]');
    if (remove) changeLine(remove.dataset.kvRemove, 0);
    if (event.target instanceof HTMLDialogElement) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.kv-header[data-menu-open]').forEach(header => {
      header.removeAttribute('data-menu-open');
      const button = header.querySelector('[data-kv-menu]');
      button.setAttribute('aria-expanded', 'false');
      button.focus();
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', event => { if (event.persisted) request('cart.js').then(updateCounts).catch(() => {}); });
  initialize();
})();


(() => {
  function enhanceStory(root) {
    if (root.hasAttribute('data-kv-story-ready')) return;
    const source = root.querySelector('[data-story-source]');
    const track = root.querySelector('[data-story-pages]');
    if (!source || !source.textContent.trim()) return;
    const groups = [];
    let group = {heading:'', content:[], images:[]};
    groups.push(group);
    for (const node of source.children) {
      if (/^H[1-6]$/.test(node.tagName)) {
        group = {heading:node.textContent.trim(),content:[],images:[]};
        groups.push(group);
        continue;
      }
      const pictures = node.matches('img') ? [node] : [...node.querySelectorAll('img')];
      for (const picture of pictures) {
        const src = picture.getAttribute('src');
        if (src) group.images.push({src:new URL(src,location.href).href,alt:picture.alt || root.getAttribute('aria-label'),caption:picture.alt || '',fit:'contain'});
      }
      const content = node.cloneNode(true);
      if (content.matches('img')) continue;
      content.querySelectorAll('img,meta').forEach(image => image.remove());
      if (!content.textContent.trim()) continue;
      content.removeAttribute('class');
      for (const link of content.querySelectorAll('a[href]')) {
        const url = new URL(link.href, location.href);
        if (['kaffebonor-2.myshopify.com','ftnwsh-es.myshopify.com',location.hostname].includes(url.hostname)) link.href = url.pathname + url.search + url.hash;
      }
      group.content.push(content);
    }
    const generated = [];
    const inlineImages = groups.flatMap(group => group.images);
    for (const group of groups) {
      for (const content of group.content) {
        const page = document.createElement('div');
        page.setAttribute('data-story-page','');
        if (group.heading) { const title = document.createElement('h2'); title.textContent = group.heading; page.append(title); }
        if (group.images[0]) page.dataset.storyImage = JSON.stringify(group.images[0]);
        page.append(content); page.hidden = true; generated.push(page);
      }
    }
    if (!generated.length) return;
    track.append(...generated);
    const pages = [...track.querySelectorAll('[data-story-page]')];
    const previous = root.querySelector('[data-story-prev]');
    const next = root.querySelector('[data-story-next]');
    const status = root.querySelector('[data-story-status]');
    const photo = root.querySelector('.kv-roaster-hero__image');
    const media = root.querySelector('[data-story-media]');
    const images = JSON.parse(root.querySelector('[data-story-images]').textContent);
    const pool = [...images, ...inlineImages].filter((image,i,all)=>all.findIndex(other=>other.src===image.src)===i);
    const slideImages = pages.map((page,i) => {
      if (!inlineImages.length) return images[i % images.length];
      return page.dataset.storyImage ? JSON.parse(page.dataset.storyImage) : pool[i % pool.length];
    });
    for (let i=1;i<slideImages.length;i++) {
      if (slideImages[i].src===slideImages[i-1].src) slideImages[i]=pool.find(image=>image.src!==slideImages[i-1].src) || slideImages[i];
    }
    const overrides = JSON.parse(root.querySelector('[data-story-overrides]')?.textContent || '[]');
    overrides.forEach((image, i) => { if (image && i < slideImages.length) slideImages[i] = image; });
    for (const image of [...pool, ...overrides.filter(Boolean)]) { const preload = new Image(); preload.src = image.src; }
    const beanNav = root.querySelector('[data-story-beans]');
    const beans = beanNav ? pages.map((page, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'kv-bean';
      const heading = page.querySelector('h2')?.textContent || 'Introduktion';
      button.setAttribute('aria-label', 'Sida ' + (i + 1) + ': ' + heading);
      button.title = button.getAttribute('aria-label');
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      button.append(icon);
      button.addEventListener('click', () => show(i));
      button.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? pages.length - 1 : Math.max(0, Math.min(pages.length - 1, i + (event.key === 'ArrowRight' ? 1 : -1)));
        show(target);
        beans[target].focus({preventScroll:true});
      });
      beanNav.append(button);
      return button;
    }) : [];
    let index = 0;
    function show(value) {
      index = Math.max(0, Math.min(pages.length - 1, value));
      pages.forEach((page, i) => { page.hidden = i !== index; });
      previous.disabled = index === 0;
      next.disabled = index === pages.length - 1;
      status.textContent = (index + 1) + ' / ' + pages.length;
      beans.forEach((bean, i) => { bean.setAttribute('aria-current', String(i === index)); bean.tabIndex = i === index ? 0 : -1; });
      track.scrollTop = 0;
      const image = slideImages[index];
      photo.removeAttribute('srcset');
      photo.src = image.src;
      photo.alt = image.alt;
      media.dataset.fit = image.fit;
    }
    previous.addEventListener('click', () => show(index - 1));
    next.addEventListener('click', () => show(index + 1));
    root.querySelector('[data-story-home]').addEventListener('click', () => show(0));
    root.querySelector('[data-story-start]').addEventListener('click', () => { show(1); track.focus({preventScroll:true}); });
    track.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      show(event.key === 'Home' ? 0 : event.key === 'End' ? pages.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    let gesture = null;
    let suppressClickUntil = 0;
    root.addEventListener('pointerdown', event => {
      if (!event.isPrimary || event.button !== 0 || event.target.closest('button, a, input, select, summary')) return;
      gesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
      root.setPointerCapture(event.pointerId);
      if (event.pointerType === 'mouse') event.preventDefault();
    });
    root.addEventListener('pointerup', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        suppressClickUntil = Date.now() + 400;
        show(index + (dx < 0 ? 1 : -1));
      }
      if (root.hasPointerCapture(event.pointerId)) root.releasePointerCapture(event.pointerId);
    });
    root.addEventListener('pointercancel', () => { gesture = null; });
    root.addEventListener('lostpointercapture', () => { gesture = null; });
    root.addEventListener('click', event => {
      if (Date.now() < suppressClickUntil && !event.target.closest('button')) { event.preventDefault(); event.stopPropagation(); }
    }, true);
    root.querySelector('[data-story-fallback]').hidden = true;
    root.querySelector('[data-story-controls]').hidden = false;
    root.querySelector('[data-story-start]').hidden = false;
    root.setAttribute('data-kv-story-ready','');
    show(0);
  }
  const init = () => document.querySelectorAll('[data-kv-story]').forEach(enhanceStory);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  function initProfile(root) {
    if (root.hasAttribute('data-profile-ready')) return;
    const tabs = [...root.querySelectorAll('[data-profile-tab]')];
    const panels = [...root.querySelectorAll('[data-profile-panel]')];
    if (tabs.length !== panels.length || !tabs.length) return;
    root.querySelector('[data-profile-tabs]').setAttribute('role','tablist');
    function select(index, focus = false) {
      tabs.forEach((tab,i)=>{
        tab.setAttribute('aria-selected',String(i===index));
        tab.tabIndex=i===index?0:-1;
        panels[i].hidden=i!==index;
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab,i)=>{
      tab.setAttribute('role','tab');
      tab.setAttribute('aria-controls',panels[i].id);
      panels[i].setAttribute('role','tabpanel');
      panels[i].setAttribute('aria-labelledby',tab.id);
      panels[i].tabIndex=0;
      tab.addEventListener('click',event=>{event.preventDefault();select(i);});
      tab.addEventListener('keydown',event=>{
        let index;
        if(event.key==='ArrowRight')index=(i+1)%tabs.length;
        if(event.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;
        if(event.key==='Home')index=0;
        if(event.key==='End')index=tabs.length-1;
        if(index!==undefined){event.preventDefault();select(index,true);}
      });
    });
    root.setAttribute('data-profile-ready','');
    const linked=panels.findIndex(panel=>'#'+panel.id===location.hash);
    select(linked<0?0:linked);
  }
  const init=()=>document.querySelectorAll('[data-kv-profile]').forEach(initProfile);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(() => {
  function initAcademy() {
    document.querySelectorAll('[data-academy]').forEach(root => {
      if (root.dataset.academyReady) return;
      root.dataset.academyReady = 'true';
      const filters = root.querySelector('[data-academy-filters]');
      if (!filters) return;
      const cards = [...root.querySelectorAll('[data-academy-card]')];
      const buttons = [...filters.querySelectorAll('button')];
      buttons.forEach(button => {
        button.hidden = button.dataset.academyFilter !== 'all' && !cards.some(card => card.dataset.topic === button.dataset.academyFilter);
        button.addEventListener('click', () => {
          const topic = button.dataset.academyFilter;
          cards.forEach(card => { card.hidden = topic !== 'all' && card.dataset.topic !== topic; });
          buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          root.querySelector('[data-academy-status]').textContent = cards.filter(card => !card.hidden).length + ' artiklar visas';
        });
      });
      filters.hidden = false;
    });
    document.querySelectorAll('[data-academy-article]').forEach(root => {
      if (root.dataset.academyReady) return;
      root.dataset.academyReady = 'true';
      const body = root.querySelector('[data-academy-body]');
      body.querySelectorAll('p').forEach(paragraph => {
        if (!paragraph.textContent.trim() && !paragraph.querySelector('img,iframe,video,svg')) paragraph.remove();
      });
      const title = root.querySelector('h1').textContent.trim().toLocaleLowerCase('sv');
      const first = body.firstElementChild;
      if (first?.matches('h2') && first.textContent.trim().toLocaleLowerCase('sv') === title) first.remove();
      const headings = [...body.querySelectorAll('h2')];
      if (headings.length < 3) return;
      const toc = root.querySelector('[data-academy-toc]');
      headings.forEach((heading, i) => {
        if (!heading.id) heading.id = 'academy-chapter-' + (i + 1);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        toc.querySelector('ol').append(item);
      });
      toc.hidden = false;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAcademy); else initAcademy();
  document.addEventListener('shopify:section:load', initAcademy);
})();
// KB — Policysidor: innehållsförteckningen är öppen på dator men fälls ihop på mobil
document.querySelectorAll('[data-policy-toc]').forEach(toc => {
  if (window.matchMedia('(max-width: 899px)').matches) toc.open = false;
});
